export const getGoalAttitudeIcon = (value: number) => {
  if (value < 20) {
    return '😩';
  } else if (value >= 20 && value < 40) {
    return '😔';
  } else if (value >= 40 && value < 60) {
    return '🙂';
  } else if (value >= 60 && value < 80) {
    return '😊';
  } else if (value >= 80) {
    return '🔥';
  }
};
